import { useContext } from 'react';
import { InviteToOrganizationModal } from "./InviteToOrganizationModal";
import { TransferContext } from "./OrganizationTransferContext";
import { jsx as _jsx } from "react/jsx-runtime";
export const InvitationalModalWrapper = () => {
  const {
    isInvitationModalOpen,
    setIsInvitationModalOpen,
    organization
  } = useContext(TransferContext);
  return /*#__PURE__*/_jsx(InviteToOrganizationModal, {
    isOpen: isInvitationModalOpen,
    onInviteSent: () => setIsInvitationModalOpen(false),
    onRequestClose: () => setIsInvitationModalOpen(false),
    organization: organization,
    "data-sentry-element": "InviteToOrganizationModal",
    "data-sentry-component": "InvitationalModalWrapper",
    "data-sentry-source-file": "OrganizationInvitationModalWrapper.tsx"
  });
};